var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content--sinoreg ImportarImagensEmLote p-1"},[_c('header-blue',[_c('h4',[_vm._v("Importar imagens em lote")])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }